export default function getResource(label) {
    const resources = {
        freeShippingMessage: 'Free shipping on orders over $50'
    };
    return resources[label];
}
